import { useEffect, useRef } from 'react'

import { useNavigate } from 'react-router-dom'

import { Layout, SpinnerWheel, Text } from '@loadsmart/miranda-react'

import { LOGIN_STORAGE_USER, REDIRECT_TO_STORAGE_KEY } from 'auth/domain/User'

import useOauth2Flow from 'auth/ui/hooks/useOauth2'
import { AnalyticsEvent } from 'core/analytics/events'
import useAnalytics from 'core/analytics/useAnalytics'
import { LocalStorageClient } from 'core/infra/storage/LocalStorageClient'

const LoginThroughBIPCallback = () => {
  const navigate = useNavigate()
  const { track } = useAnalytics()
  const authTrackedRef = useRef(false)
  const storage = new LocalStorageClient()

  function getUserData() {
    try {
      const userData = storage.get<string | { email: string; [key: string]: unknown }>(LOGIN_STORAGE_USER)
      if (!userData) return null

      let user: { email: string; [key: string]: unknown }
      if (typeof userData === 'string') {
        user = JSON.parse(userData)
      } else {
        user = userData
      }

      return {
        email: user.email,
      }
    } catch {
      return null
    }
  }

  function onLoginSuccess() {
    if (!authTrackedRef.current) {
      authTrackedRef.current = true
      const userData = getUserData()
      track(AnalyticsEvent.Authentication, { 
        authFlow: 'BIP', 
        authStage: 'success',
        ...(userData ? { email: userData.email } : {})
      })
    }

    const redirectTo = localStorage.getItem(REDIRECT_TO_STORAGE_KEY)

    if (redirectTo) {
      localStorage.removeItem(REDIRECT_TO_STORAGE_KEY)
    }

    navigate(redirectTo ?? '/demo')
  }

  function onLoginFailure(error: Error) {
    console.error(error)
    const userData = getUserData()
    track(AnalyticsEvent.Authentication, { 
      authFlow: 'BIP',
      authStage: 'failure',
      error: error.message || 'Unknown error',
      ...(userData ? { email: userData.email } : {})
    })
    navigate('/')
  }

  const { handleLogInCallback } = useOauth2Flow({ onLoginSuccess, onLoginFailure })

  useEffect(() => {
    handleLogInCallback()
  }, [handleLogInCallback])

  return (
    <Layout.Stack justify="center" align="center" style={{ margin: 'auto', height: '100vh' }}>
      <Text variant="heading-sm-bold">Authentication in progress...</Text>
      <SpinnerWheel size="48" />
    </Layout.Stack>
  )
}

export default LoginThroughBIPCallback
